import { useEffect, useState } from 'react'
import { Box, Button, Checkbox, FormControlLabel, MenuItem, TextField, Typography } from '@mui/material'
import apiClient from '../../utils/apiClient'
import organizationSessionStore from '../../stores/organizationSessionStore'

function rawChange(definition, raw, clear = false) {
	if (clear || raw === undefined || raw === null) return { definitionId: definition.id, clear: true }
	if (definition.type === 'BOOLEAN') return { definitionId: definition.id, value: Boolean(raw) }
	if (definition.type === 'INTEGER') return { definitionId: definition.id, value: Number(raw) }
	if (definition.type === 'DECIMAL') return { definitionId: definition.id, value: String(raw) }
	if (definition.type === 'SINGLE_SELECT') return { definitionId: definition.id, optionId: raw }
	return { definitionId: definition.id, value: raw }
}

export default function CustomFieldInputs({ values = {}, onChange }) {
	const [definitions, setDefinitions] = useState([])
	useEffect(() => {
		let alive = true
		apiClient.get('/api/custom-field-definitions').then(response => { if (alive) setDefinitions(response.data.definitions) }).catch(() => { if (alive) setDefinitions([]) })
		return () => { alive = false }
	}, [organizationSessionStore.contextGeneration])
	if (!definitions.length) return null
	return <Box sx={{ mt: 2, mb: 2 }}><Typography variant="h6">Пользовательские поля</Typography>
		{definitions.map(definition => <Box key={definition.id} sx={{ mt: 1 }}>
			{definition.type === 'BOOLEAN' ? <FormControlLabel label={definition.label} control={<Checkbox checked={values[definition.id] === true} onChange={event => onChange(definition, event.target.checked, false)} />} /> : definition.type === 'SINGLE_SELECT' ? <TextField fullWidth select label={definition.label} value={values[definition.id] ?? ''} onChange={event => onChange(definition, event.target.value, event.target.value === '')}><MenuItem value="">Не выбрано</MenuItem>{definition.options.filter(option => !option.archivedAt).map(option => <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>)}</TextField> : <TextField fullWidth label={definition.label} value={values[definition.id] ?? ''} onChange={event => onChange(definition, event.target.value, false)} />}
			{values[definition.id] !== undefined && <Button size="small" onClick={() => onChange(definition, undefined, true)}>Очистить</Button>}
		</Box>)}
	</Box>
}

export { rawChange }
